exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stadium-info__logo-uploader > .ant-upload {\n  width: 128px;\n  height: 128px;\n  border-radius: 100%;\n}\n.stadium-info__logo-uploader .ant-upload-select-picture-card i {\n  font-size: 32px;\n  color: #999;\n}\n.stadium-info__logo-uploader > .ant-upload img {\n  width: 128px;\n  height: 128px;\n  border-radius: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);

// exports
